import { Component, OnInit, HostListener } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import * as uuid from 'uuid';
import { StartupModel } from '../classes/model';
import { RdsServerService } from '../services/rds-server.service';
import { ImageUploadService } from '../services/image-upload.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
  showOptions = false;
  submitted:Boolean = false;
  constructor(
    private _rdsServer: RdsServerService,
    private imageUploadService: ImageUploadService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar) { }

  ngOnInit(): void {
    this.submitted = false;
    document.getElementById("one").classList.add("active");
    document.getElementById("two").classList.add("inactive")

    this._rdsServer.getIndustryList().subscribe(res => {
      for (const e in res) {
        this.industries.push(res[e])
      }
    })

    this._rdsServer.getStateList().subscribe(res => {
      for (const e in res) {
        this.states.push(res[e])
      }
    });

    this._rdsServer.getAllSectorList().subscribe(res => {
      const uniqueSectors = [];
      const others = [];
    
      for (const e in res) {
        const newText = res[e]['text'];
        if (!uniqueSectors.some(sector => sector.text === newText)) {
          uniqueSectors.push(res[e]);
        }
      }
    
      // Sort uniqueSectors by text
      uniqueSectors.sort((a, b) => {
        if (a.text === "Others") return 1; // "Others" should come last
        if (b.text === "Others") return -1; // "Others" should come last
        return a.text.localeCompare(b.text); // Sort alphabetically for other values
      });
    
      // Append "Others" to the end if it exists
      const othersIndex = uniqueSectors.findIndex(sector => sector.text === "Others");
      if (othersIndex !== -1) {
        others.push(uniqueSectors[othersIndex]);
        uniqueSectors.splice(othersIndex, 1);
      }
    
      // Concatenate uniqueSectors and others
      this.sectors = [...uniqueSectors, ...others];
    });


  }


  /* FORM GROUP */
  startupData = new UntypedFormGroup({
    sName: new UntypedFormControl('', Validators.required),
    sBrief: new UntypedFormControl('', Validators.required),
    sEmail: new UntypedFormControl('', [Validators.required, Validators.email]),
    sSector: new UntypedFormControl(null, Validators.required),
    sMobile: new UntypedFormControl('', Validators.required),
    sIndustry: new UntypedFormControl(null, Validators.required),
    sState: new UntypedFormControl(null, Validators.required),
    sCity: new UntypedFormControl(null, Validators.required),
    sInterest: new UntypedFormGroup({
      all: new UntypedFormControl(false),
      mentoring: new UntypedFormControl(false),
      incubation: new UntypedFormControl(false),
      acceleration: new UntypedFormControl(false),
      investment: new UntypedFormControl(false),
    }),
    fundOrBoot: new UntypedFormControl(true),
    sWebsite: new UntypedFormControl(''),
    sAppLink: new UntypedFormControl(''),
    stage: new UntypedFormControl('', Validators.required),
    test: new UntypedFormControl(''),
    sFname: new UntypedFormControl('', Validators.required),
    sLname: new UntypedFormControl('', Validators.required),
    incubatedAt: new UntypedFormControl(''),
  });

  // Logo Upload  
  logoBlob;
  logoExtension;
  logoKeyName;
  logoBase64: any = '../../assets/upload2.svg';
  // Pitch Deck Upload
  pitchBlob;
  pitchExtension;
  pitchKeyName;
  pitchBase64: any = '../../assets/upload2.svg';
  // '../../assets/1x/Asset 3.png'
  pitchChanged = false;
  // Arrays for drop downs
  cities = [];
  industries = [];
  sectors = [];
  states = [];
  // variable to track page number
  activeSection = 1;

  // usage log
  usageLog = {};

  getSectorsList() {

    this.sectors = []

    var value = this.startupData.get('sIndustry').value;

    for (const e in this.industries) {
      if (this.industries[e]['text'] == value) {
        this._rdsServer.getSectorList(this.industries[e]['id']).subscribe(res => {
          for (const e in res)
            this.sectors.push(res[e])
        })
      }
    }
  }

  firstCap(str) {
    return (str[0].toUpperCase() + str.substring(1, str.length));
  }

  checkAvailableOptions(type, err) { }

  stateSelected() {
    this.cities = [];
    var value = this.startupData.get('sState').value;

    for (const e in this.states) {

      if (this.states[e]['text'] == value) {
        this._rdsServer.getCityList(this.states[e]['id']).subscribe(res => {

          for (const e in res)
            this.cities.push(res[e]);
        })
      }
    }
  }
  // ======================= functions to change section ================================
  next() {
    if (this.activeSection == 1) {
      document.getElementById("two").classList.replace("inactive", "active")

      document.getElementById("dot-con").style.backgroundColor = 'white';
      setTimeout(() => {
        document.getElementById("dot-con").style.backgroundColor = 'transparent';
        document.getElementById("one").classList.replace("active", "inactive")
      }, 500);
    }
    if (this.activeSection == 2) {
      return 0;
    }
    this.activeSection += 1;
  }

  previous() {
    if (this.activeSection == 2) {
      document.getElementById("one").classList.replace("inactive", "active")

      document.getElementById("dot-con").style.backgroundColor = 'white';
      setTimeout(() => {
        document.getElementById("dot-con").style.backgroundColor = 'transparent';
        document.getElementById("two").classList.replace("active", "inactive")
      }, 500);
    }
    if (this.activeSection == 1) {
      return 0;
    }
    this.activeSection -= 1;
  }
  // ======================= functions to change section ================================

  /* function to upload pitch deck */
  pitchUpload(file) {

    if (file[0].size > 5242880) {
      alert("File is too big! Max size allowed is 5MB");
      return 0;
    };

    this.pitchBlob = file[0];
    this.pitchExtension = this.pitchBlob.name.split('.').pop();
    this.pitchKeyName = uuid.v4() + '.' + this.pitchExtension;
    this.pitchChanged = true;
    // convert to base64 and store in usageLog object
    const reader = new FileReader();
    reader.readAsDataURL(file[0]);
    reader.onloadend = _event => {
      this.usageLog['pitch_base64'] = reader.result;
    }
    if (this.pitchExtension == 'pdf')
      this.pitchBase64 = '../../assets/pdfIco.png';
    else
      this.pitchBase64 = '../../assets/docx.png';
  }

  /* function to upload logo */
  uploadLogo(file) {

    if (file[0].size > 2097152) {
      alert("File is too big! Max size allowed is 2MB");
      return 0;
    };

    this.logoBlob = file[0];
    const reader = new FileReader();
    reader.readAsDataURL(file[0]);
    reader.onloadend = _event => {
      this.logoBase64 = reader.result;
    }
    this.logoExtension = this.logoBlob.name.split('.').pop();
    this.logoKeyName = uuid.v4() + '.' + this.logoExtension;
  }

  // function for checkboxes
  checkAll() {

    if (this.startupData.get('sInterest').value['all'] == false) {
      if (!this.startupData.get('sInterest').value['mentoring'])
        this.startupData.controls.sInterest['controls'].mentoring.patchValue(true)
      if (!this.startupData.get('sInterest').value['incubation'])
        this.startupData.controls.sInterest['controls'].incubation.patchValue(true)
      if (!this.startupData.get('sInterest').value['acceleration'])
        this.startupData.controls.sInterest['controls'].acceleration.patchValue(true)
      if (!this.startupData.get('sInterest').value['investment'])
        this.startupData.controls.sInterest['controls'].investment.patchValue(true)
    }

    if (this.startupData.get('sInterest').value['all'] == true) {
      if (this.startupData.get('sInterest').value['mentoring'])
        this.startupData.controls.sInterest['controls'].mentoring.patchValue(false)
      if (this.startupData.get('sInterest').value['incubation'])
        this.startupData.controls.sInterest['controls'].incubation.patchValue(false)
      if (this.startupData.get('sInterest').value['acceleration'])
        this.startupData.controls.sInterest['controls'].acceleration.patchValue(false)
      if (this.startupData.get('sInterest').value['investment'])
        this.startupData.controls.sInterest['controls'].investment.patchValue(false)
    }

  }
  // function for checkboxes
  processAll(type) {

    if (type == 2 && !this.startupData.get('sInterest').value['mentoring']) {
      this.startupData.controls.sInterest['controls'].all.patchValue(false);
    }
    if (type == 3 && !this.startupData.get('sInterest').value['incubation']) {
      this.startupData.controls.sInterest['controls'].all.patchValue(false);
    }
    if (type == 4 && !this.startupData.get('sInterest').value['acceleration']) {
      this.startupData.controls.sInterest['controls'].all.patchValue(false);
    }
    if (type == 5 && !this.startupData.get('sInterest').value['investment']) {
      this.startupData.controls.sInterest['controls'].all.patchValue(false);
    }
    if (this.checkIfAllAreTrue()) {
      this.startupData.controls.sInterest['controls'].all.patchValue(true)
    }
  }
  // function for checkboxes
  checkIfAllAreTrue() {
    return (this.startupData.get('sInterest').value['mentoring'] && this.startupData.get('sInterest').value['incubation'] && this.startupData.get('sInterest').value['acceleration'] && this.startupData.get('sInterest').value['investment']);
  }

  startupStorage = new StartupModel;

  checkFileUploads() {
    if (this.pitchKeyName == undefined || this.pitchKeyName == null) {
      return false;
    }
    return true;
  }

  stageWarn = false;
  interestWarn = false;
  briefWarn = false;
  loading = false;

  /* SUBMIT FORM FUNCTION */
  submit() {

    if (this.loading) {
      return;
    }
    if (!this.startupData.valid) {
      document.getElementById("snack").classList.add('appear');
      this.message = 'Please Enter All Required Details !';

      this.stageWarn = true;
      this.interestWarn = true;
      this.briefWarn = true;

      setTimeout(() => {
        document.getElementById("snack").classList.remove('appear');
      }, 500);
      return 0;
    }
    else if (!this.checkFileUploads()) {
      document.getElementById("snack").classList.add('appear');
      this.message = 'Upload Pitch Deck First !';
      setTimeout(() => {
        document.getElementById("snack").classList.remove('appear');
      }, 500);
      return 0;
    }
    this.loading = true;
    console.log(this.startupData.value)

    this.startupStorage.id = uuid.v4();

    this.startupStorage.name = this.startupData.value.sName;
    this.startupStorage.industry = this.startupData.value.sIndustry;
    this.startupStorage.sector = this.startupData.value.sSector;
    if (this.startupData.value.fundOrBoot) {
      var fB = 'bootstrap'
    }
    else if (!this.startupData.value.fundOrBoot) {
      var fB = 'funded'
    }

    this.startupStorage.fundedOrBoot = fB;
    this.startupStorage.stage = this.startupData.value.stage;
    this.startupStorage.interests = JSON.stringify(this.startupData.value.sInterest);
    this.startupStorage.description = this.startupData.value.sBrief;
    //
    this.startupStorage.pitch = this.pitchKeyName;
    this.startupStorage.logo = this.logoKeyName;
    //
    this.startupStorage.state = this.startupData.value.sState
    this.startupStorage.city = this.startupData.value.sCity;
    this.startupStorage.email = this.startupData.value.sEmail;
    this.startupStorage.mobile = this.startupData.value.sMobile;
    this.startupStorage.website = this.startupData.value.sWebsite;
    this.startupStorage.mobileApp = this.startupData.value.sAppLink;
    //
    this.startupStorage.webSource = 'Lucknow';
    this.startupStorage.status = 'Response Awaited';
    //
    this.startupStorage.StartupApply_FirstName = this.startupData.value.sFname;
    this.startupStorage.StartupApply_LastName = this.startupData.value.sLname;

    this.startupStorage.incubatedAt = "";

    console.log(this.startupStorage);

    document.getElementById("snack").classList.add("appear-slide");

    // document.getElementById("snack").style.color = 'red'
    // this.message = "Applications Closed !";
    // return
    this._rdsServer.getStartupLogoImageUrl(this.logoKeyName, this.logoExtension).subscribe(resLogo => {
      console.log(resLogo);
      this.usageLog['logo_url_generated'] = true;
      this._rdsServer.getStartupPitchImageUrl(this.pitchKeyName, this.pitchExtension).subscribe(resPitch => {
        console.log(resPitch);
        this.usageLog['pitch_url_generated'] = true;
        this.imageUploadService.uploadImage(resLogo['ImageUrl'], this.logoExtension, this.logoBlob).subscribe(resLogoUplad => {
          console.log(resLogoUplad);
          this.usageLog['logo_uploaded'] = true;
          this.imageUploadService.uploadImage(resPitch['ImageUrl'], this.pitchExtension, this.pitchBlob).subscribe(resPitchUpload => {
            console.log(resPitchUpload);
            this.usageLog['pitch_uploaded'] = true;
            this._rdsServer.postStartupForm(this.startupStorage).subscribe(res => {

              // this.dialog.open(SuccessPopupComponent, { panelClass: 'success-popup' }).afterClosed().subscribe(() => window.location.reload());
              this.submitted = true;
              console.log( this.submitted)
              console.log(res);
              this.loading = false;
              document.getElementById("snack").classList.add("appear-slide");
              this.message = "Form Submitted Successfully !";
            }, err => this.initiateReportSending(err));
          }, err => this.initiateReportSending(err));
        }, err => this.initiateReportSending(err));
      }, err => this.initiateReportSending(err));
    }, err => this.initiateReportSending(err));

  }

  show() {
    this.showOptions = !this.showOptions;
  }

  message = '';
  textCount = 0;

  changeCharCount(str) {
    this.textCount = str.length;
  }

  changeType(str) {
    var fund = document.getElementById("fund")
    var boot = document.getElementById("boot")
    var active = document.getElementById("active")
    if (str == 'funded') {
      boot.style.color = 'black'
      fund.style.color = 'white'
      active.style.right = '122px'
      this.startupData.patchValue({ fundOrBoot: true })
    }
    else if (str == 'bootstrap') {
      boot.style.color = 'white'
      fund.style.color = 'black'
      active.style.right = '2px'
      this.startupData.patchValue({ fundOrBoot: false })
    }
    console.log(this.startupData.value.fundOrBoot)
  }

  mouseEnter(id) {
    document.getElementById(id).style.opacity = '1';
    document.getElementById(id).style.display = 'block';
  }
  mouseLeave(id) {
    document.getElementById(id).style.opacity = '0';
    document.getElementById(id).style.display = 'none';
  }

  initiateReportSending(err) {
    this.usageLog['error'] = err;
    this.usageLog['form_data'] = this.startupStorage;
    this.usageLog['logo_base64'] = this.logoBase64;
    this._rdsServer.getLinkAndUpload(`${this.startupData.value.sName}-${new Date()}`, 'incubator-logs-bucket/meity', this.usageLog, 'txt').then(res => {
      this.loading = false;
      this.snackbar.open('An Error Occured, Please try again!', 'OK')
    });
  }

}